import hexToHsl from 'hex-to-hsl';
import { nth } from 'ramda';
const DEFAULT_THEME_HUE = 262;
const DEFAULT_THEME_SATURATION = '69%';
const DEFAULT_THEME_LIGHTNESS = '51%';
export const hexToHSL = (color: any) => {
  return hexToHsl(color);
};
export const setTheme = (hsl: any, secondary: any) => {
  const hue: any = nth(0, hsl) || DEFAULT_THEME_HUE;
  const saturation = `${nth(1, hsl)}%` || DEFAULT_THEME_SATURATION;
  const lightness = `${nth(2, hsl)}%` || DEFAULT_THEME_LIGHTNESS;
  document.documentElement.style.setProperty('--primary-color-hue', hue);
  document.documentElement.style.setProperty(
    '--primary-color-saturation',
    saturation
  );
  document.documentElement.style.setProperty(
    '--primary-color-lightness',
    lightness
  );
  document.documentElement.style.setProperty('--secondary-color', secondary);
};
